import { Directive, Inject, ViewChild } from "@angular/core";

import { SELECT_CLASSES, SelectClasses } from "./base-select-classes";
import {
  NewOptionLayoutDirective,
  OptionLayoutDirective,
  SelectedOptionLayoutDirective
} from "./option-layout.directive";

@Directive()
export abstract class BaseDefaultOptionLayouts<Model> {
  @ViewChild(OptionLayoutDirective, { static: true })
  optionLayout: OptionLayoutDirective<Model>;

  @ViewChild(SelectedOptionLayoutDirective, { static: true })
  selectedOptionLayout?: SelectedOptionLayoutDirective<Model>;

  @ViewChild(NewOptionLayoutDirective, { static: true})
  newOptionLayout?: NewOptionLayoutDirective<Model>;

  constructor(@Inject(SELECT_CLASSES) public selectClasses: SelectClasses) {}
}
